import { render } from "./VentaGanancias.vue?vue&type=template&id=1c6ab89e&scoped=true"
import script from "./VentaGanancias.vue?vue&type=script&lang=js"
export * from "./VentaGanancias.vue?vue&type=script&lang=js"

import "./VentaGanancias.vue?vue&type=style&index=0&id=1c6ab89e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6ab89e"]])

export default __exports__